import React from 'react';
import { T } from '../traks';
import { A } from '../routes';
import { site_name } from '../Site';

function TermsOfUse(props) {
	return (
		<div className="container ad_privacy_policy p-4">
		<T context="terms_of_use" deps={[site_name, A]}>
		__HUGE_TERMS_OF_USE_CHUNK__
		</T>
		</div>
	);
}

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/p/TermsOfUse.js